import { render, staticRenderFns } from "./inquirylist.vue?vue&type=template&id=970f0784"
import script from "./inquirylist.vue?vue&type=script&lang=js"
export * from "./inquirylist.vue?vue&type=script&lang=js"
import style0 from "./inquirylist.vue?vue&type=style&index=0&id=970f0784&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports